import { useMemo } from "react";
import { getHeadersForCategory } from "../../utils/headers";
import stringifyValues from "../../utils/stringifyValues";
import type {
  ResultsTableProps,
  VehicleData,
  VehicleTableData
} from "@dealer-center/ddc-pages-inventory-archiver-interface";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { DataTable } from "./DataTable";

const ResultsTable = (props: ResultsTableProps) => {
  const data = useMemo<VehicleData[]>(
    () => stringifyValues(props.data),
    [props.data]
  );

  const rows = useMemo<VehicleTableData[]>(() => {
    return data.map((item: VehicleData, index: number) => {
      const row: VehicleTableData = {
        key: `row-${index}`,
        className: "row",
        title: `Vehicle ${index + 1}`
      };
      props.checkedCategories.forEach(category => {
        getHeadersForCategory(category).forEach(key => {
          const value = (item as unknown as Record<string, unknown>)[key];
          row[key] = [value?.toString() ?? ""];
        });
      });
      return row;
    });
  }, [data, props.checkedCategories]);

  const columns = useMemo<TypeSafeTableColumns<VehicleTableData>>(
    () =>
      props.checkedCategories.flatMap(category =>
        getHeadersForCategory(category).map((key: string) => ({
          className: `column-${key?.toLowerCase()}`,
          dataIndex: key as keyof VehicleTableData,
          title: key,
          key,
          render: (value: string | string[] | undefined) =>
            Array.isArray(value) ? value[0] : (value ?? "")
        }))
      ),
    [props.checkedCategories]
  );

  return (
    <DataTable
      checkedCategories={props.checkedCategories}
      columns={columns}
      headerData={data}
      rows={rows}
      onToggleHeaders={props.onToggleHeaders}
    />
  );
};

export default ResultsTable;
